







































import { Vue, Component, Watch } from 'vue-property-decorator'
import BasicInfo from "./BasicInfo.vue"
const countries = require("./countries")

import moment from "moment"

@Component({
  components: {
    BasicInfo
  }
})
export default class KYCStepper extends Vue {

}
